// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3NwEh","error":"Textarea_error__21Cmm","readonly":"Textarea_readonly__VMsy_","disabled":"Textarea_disabled__16KuK"};